import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
export function CredentialsSection() {
  const {
    language
  } = useLanguage();
  const content = {
    en: [{
      num: '7+',
      label: 'Years Tattooing'
    }, {
      num: '2018',
      label: 'Started Tattooing'
    }, {
      num: '100%',
      label: 'Custom Designs'
    }, {
      num: '∞',
      label: 'Permanent Fine Art'
    }],
    es: [{
      num: '7+',
      label: 'Años Tatuando'
    }, {
      num: '2018',
      label: 'Inicio en el Tatuaje'
    }, {
      num: '100%',
      label: 'Diseños Personalizados'
    }, {
      num: '∞',
      label: 'Arte Permanente'
    }]
  };
  const stats = content[language];
  return <section className="bg-brand-charcoal py-16 border-b border-brand-gold/30" data-id="element-19">
      <div className="max-w-7xl mx-auto px-6" data-id="element-20">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-4" data-id="element-21">
          {stats.map((stat, index) => <motion.div key={index} className="border-t-2 border-brand-gold pt-6 text-center" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} data-id="element-22">
              <div className="text-4xl md:text-5xl font-serif text-brand-gold mb-2" data-id="element-23">
                {stat.num}
              </div>
              <div className="text-brand-white font-sans text-xs md:text-sm tracking-widest uppercase opacity-80" data-id="element-24">
                {stat.label}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}